module.exports = __webpack_public_path__ + "img/0xef4073a0f2b305a38ec4050e4d3d28bc40ea63f5.562df077.png";